import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import vuetify from './plugins/vuetify'
import { loadFonts } from './plugins/webfontloader'
import { createPinia } from 'pinia'
import axios from 'axios'

const pinia = createPinia()
loadFonts()

// set axios default
axios.defaults.baseURL = process.env.VUE_APP_API

createApp(App)
  .use(router)
  .use(vuetify)
  .use(pinia)
  .mount('#app')
